import parse from "html-react-parser"
import { useTranslation } from "react-i18next"

import { CourseLayout } from "@/features/training/components/layouts/course-layout"
import { CourseSection } from "@/features/training/components/layouts/course-section"

export function ChallengesPage() {
  const { t } = useTranslation("", { keyPrefix: "training.challenges" })

  return (
    <CourseLayout>
      <CourseSection>
        <h2> {t("content.challenges")}</h2>
        <p>{parse(t("content.intro_text"))}</p>
      </CourseSection>
      <CourseSection>
        <h3> {t("content.hallucinations_header")}</h3>
        <p>{parse(t("content.hall_text_1"))}</p>
        <img
          alt="Description"
          className="shadow-x border-border h-100 w-full rounded-lg border"
          src="/assets/training_images/challenges/AI-hallucination.webp"
        />
      </CourseSection>
      <CourseSection>
        <h3> {t("content.verification_header")}</h3>
        <p>{parse(t("content.verification_text"))}</p>
      </CourseSection>
      <CourseSection>
        <h3>{parse(t("content.general_models_header"))}</h3>
        <p>{parse(t("content.general_models_text"))}</p>
      </CourseSection>
    </CourseLayout>
  )
}
